import { Upload, Loader2 } from "lucide-react";
import ProgressBar from "./progress-bar-component";

export default function UploadControls({ 
  files, 
  uploading, 
  uploadProgress, 
  onUpload, 
  onClear 
}) {
  const pendingCount = files.filter((f) => f.status === "pending").length;

  return (
    <footer className="controls">
      {uploading && <ProgressBar progress={uploadProgress} isActive={uploading} />}
      <div className="buttons">
        {!!pendingCount && (
          <button
            className="btn primary"
            onClick={onUpload}
            disabled={uploading}
          >
            {uploading ? (
              <>
                <Loader2 className="spin" size={20} /> Uploading…
              </>
            ) : (
              <>
                <Upload size={20} /> Upload {pendingCount}
              </>
            )}
          </button>
        )}
        <button
          className="btn secondary"
          onClick={onClear}
          disabled={uploading}
        >
          Clear all
        </button>
      </div>
    </footer>
  );
}
